import { Box, Grid } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { useListHPO } from '@/api/hpo/hpo';
import { getHPOColumns } from './hpo/getHPOColumns';

// interface HPODataListProps {
//   handleConfirmClick?: (newData: HPOSchema, type: string) => void;
//   setDialogOpen: React.Dispatch<React.SetStateAction<boolean>>;
// }

const HPODataList = () => {
  // const { mode, patientId } = usePatientContext(); // Access context values
  // const columns = getHPOColumns({
  //   selectAction: true,
  //   deleteAction: false,
  //   handleConfirmClick,
  //   setDialogOpen,
  //   type: 'single-hpo-database',
  //   formMode: mode,
  //   formPatientId: patientId,
  // });
  const columns = getHPOColumns({});
  const { data: hpoListData } = useListHPO();

  return (
    <Box>
      <Grid
        item
        xs={12}
        sm={6}
        justifyContent={{
          xs: 'center',
          sm: 'flex-end',
        }}
        sx={{ display: 'flex', padding: '50px 0 10px 0' }}
      />
      <DataGrid
        rows={hpoListData}
        columns={columns}
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: 5,
            },
          },
        }}
        sx={{ height: 400, minWidth: 1200 }}
        pageSizeOptions={[5]}
        checkboxSelection
        disableRowSelectionOnClick
      />
    </Box>
  );
};

export default HPODataList;
